import { render, staticRenderFns } from "./app.proxies.vue?vue&type=template&id=42b37f7c&lang=pug&"
import script from "./app.proxies.vue?vue&type=script&lang=js&"
export * from "./app.proxies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports